import React from 'react'

import { Modal } from '@/components/ui'
import { Form } from '@/components/ui/form/Form'

import type { StatusFormModalProps } from '../types'

const StatusFormModal: React.FC<StatusFormModalProps> = ({
  show,
  mode,
  statusName,
  originalStatusName,
  error,
  onStatusNameChange,
  onSave,
  onCancel,
  isSaving = false,
}) => {
  const title = mode === 'add' ? 'Create Status' : 'Edit Status'
  const isUnchangedEdit = mode === 'edit' && statusName.trim() === (originalStatusName || '').trim()

  return (
    <Modal
      show={show}
      onHide={onCancel}
      title={title}
      bodyContent={
        <Form
          noValidate
          className="space-y-2"
          onSubmit={(event) => {
            event.preventDefault()
            onSave()
          }}
        >
          <label htmlFor="status-name" className="label">
            <span className="label-text text-base-content">Status Name</span>
          </label>
          <input
            id="status-name"
            type="text"
            value={statusName}
            maxLength={100}
            autoFocus
            placeholder="Enter status name"
            onChange={(event) => onStatusNameChange(event.target.value)}
            className={'input input-bordered w-full ' + (error ? 'input-error' : '')}
          />
          {error ? <p className="text-error">{error}</p> : null}
        </Form>
      }
      footerButtons={[
        {
          label: 'Save',
          onClick: onSave,
          disabled: isSaving || statusName.trim() === '' || isUnchangedEdit,
          class: 'btn-primary btn-sm',
          isLoading: isSaving,
        },
        {
          label: 'Cancel',
          onClick: onCancel,
          disabled: isSaving,
          class: 'btn-ghost btn-sm',
        },
      ]}
    />
  )
}

export default StatusFormModal
